import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SweetAlertService } from '../services/sweetalert.service';
import { storageHelper } from '../misc/storage.misc';
import { jwtTokenIdentifier, userIdentifier } from '../misc/utilities.misc';

@Injectable({
  providedIn: 'root'
})

class PermissionsService {

  constructor(
    private router: Router,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService
    ) {}

  private logoutUnauthorizedUser(): UrlTree {
    // Defense en profondeur : un compte client ('user') ne doit jamais
    // pouvoir rester connecte au backoffice, meme si un token s'y trouve.
    storageHelper.local.remove(`${jwtTokenIdentifier}`);
    storageHelper.local.remove(`${userIdentifier}`);
    this.sweetAlertService.toastWarning(
      'Acces refuse',
      5000,
      "Ce compte n'est pas autorise a acceder au backoffice."
    );
    return this.router.createUrlTree(['/auth/signin']);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.authService.isAuthenticated) {
      this.router.navigateByUrl("/auth/signin");
      return false;
    }
    if (this.authService.hasRole('user')) {
      return this.logoutUnauthorizedUser();
    }
    return true;
  }


  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.authService.isAuthenticated) {
      this.router.navigateByUrl("/auth/signin");
      return false;
    }
    if (this.authService.hasRole('user')) {
      return this.logoutUnauthorizedUser();
    }
    return true;
  }
}

export const DashGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  return inject(PermissionsService).canActivate(next, state);
}


export const canActivateChild: CanActivateChildFn = ( next: ActivatedRouteSnapshot, state: RouterStateSnapshot ): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
    return inject(PermissionsService).canActivateChild(next, state);
};

